import { FiasFields, FiasStructureStatuses } from '../types';
import { abbreviations } from '../constants/abbreviations';
import { houseTypes, houseAddTypes, flatTypes, estateStatuses } from '../constants/dataTypes';
import { FiasData } from './FiasData';

var FiasAddressElement =
/** @class */
function () {
  function FiasAddressElement(type, name, data) {
    var _this = this;

    this.type = type;
    this.name = name;
    this.data = data;

    this.isTypeMatchField = function (field) {
      var data = _this.data;

      if (data && data.abbreviation) {
        return FiasAddressElement.MATCHING_TYPES[data.abbreviation] === field;
      }

      return false;
    };

    this.removeData = function () {
      delete _this.data;
    };

    this.isEqualTo = function (element) {
      if (element && element.fiasId) {
        return _this.fiasId === element.fiasId;
      }

      return false;
    };
  }

  Object.defineProperty(FiasAddressElement.prototype, "isFederalCity", {
    get: function get() {
      if (!this.fiasId) {
        return false;
      }

      return FiasAddressElement.FEDERAL_CITIES.indexOf(this.fiasId) > -1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasAddressElement.prototype, "fiasData", {
    get: function get() {
      if (this.data && this.data.data) {
        return this.data.data;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasAddressElement.prototype, "fiasId", {
    get: function get() {
      if (this.data) {
        return this.data.fiasId;
      }
    },
    enumerable: true,
    configurable: true
  });

  FiasAddressElement.prototype.getText = function (withoutType) {
    if (withoutType === void 0) {
      withoutType = false;
    }

    var _a = this,
        name = _a.name,
        data = _a.data;

    var result = '';

    if (!name) {
      return '';
    }

    if (data) {
      var abbreviation = data.abbreviation;

      if (abbreviation) {
        var type = !withoutType ? abbreviations[abbreviation] || abbreviation : '';

        switch (abbreviation) {
          case 'Чувашия':
            result = type + " \u0427\u0443\u0432\u0430\u0448\u0438\u044F";
            break;

          case 'АО':
            {
              var text = name;

              if (name !== 'Ханты-Мансийский Автономный округ - Югра') {
                text += " " + type;
              }

              result = text;
              break;
            }

          case 'Аобл':
          case 'край':
          case 'обл':
            result = name + " " + type;
            break;

          case 'п':
            result = !withoutType ? (this.type === FiasFields.district ? 'поселение' : 'поселок') + " " + name : "" + name;
            break;

          default:
            result = type + " " + name;
        }
      }

      if (FiasData.isStead(this.fiasData)) {
        result = 'земельный участок ' + data.number;
      }

      if (FiasData.isHouse(this.fiasData)) {
        var _b = this.fiasData,
            estateStatus = _b.estateStatus,
            structureStatus = _b.structureStatus,
            structureNumber = _b.structureNumber,
            buildingNumber = _b.buildingNumber,
            number = _b.number;
        result = result + " " + estateStatuses[estateStatus];

        if (number) {
          result = result + " " + number;
        }

        if (structureStatus && structureStatus !== FiasStructureStatuses.None && structureNumber) {
          switch (structureStatus) {
            case FiasStructureStatuses.Structure:
              result = result + " \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 " + structureNumber;
              break;

            case FiasStructureStatuses.Construction:
              result = result + " c\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435 " + structureNumber;
              break;

            case FiasStructureStatuses.Liter:
              result = result + " \u043B\u0438\u0442\u0435\u0440\u0430 " + structureNumber;
              break;
          }
        }

        if (buildingNumber) {
          result = result + " \u043A\u043E\u0440\u043F\u0443\u0441 " + buildingNumber;
        }
      }

      if (FiasData.isGarHouse(this.fiasData)) {
        var _c = this.fiasData,
            houseNum = _c.houseNum,
            houseType = _c.houseType,
            addNum1 = _c.addNum1,
            addNum2 = _c.addNum2,
            addType1 = _c.addType1,
            addType2 = _c.addType2;
        result = "" + houseNum;

        if (houseType) {
          result = houseTypes[houseType] + " " + houseNum;
        }

        if (addType1) {
          result += " " + houseAddTypes[addType1] + " " + addNum1;
        }

        if (addType2) {
          result += " " + houseAddTypes[addType2] + " " + addNum2;
        }
      }

      if (FiasData.isRoom(this.fiasData)) {
        var flatType = this.fiasData.flatType;

        if (flatType) {
          result = flatTypes[flatType] + " " + name;
        } else {
          result = name;
        }
      }
    }

    return result.trim() || name;
  };

  Object.defineProperty(FiasAddressElement.prototype, "verifiableData", {
    get: function get() {
      var _a = this,
          type = _a.type,
          data = _a.data;

      if (data) {
        var name_1 = data.name,
            abbreviation = data.abbreviation,
            number = data.number,
            structureNumber = data.structureNumber,
            buildingNumber = data.buildingNumber,
            structureStatus = data.structureStatus;

        switch (type) {
          case FiasFields.house:
            return {
              number: number,
              structureNumber: structureNumber,
              structureStatus: structureStatus,
              buildingNumber: buildingNumber
            };

          default:
            return {
              name: name_1,
              abbreviation: abbreviation
            };
        }
      }

      return {
        name: this.name
      };
    },
    enumerable: true,
    configurable: true
  }); // Types (abbrevs) that match fields labels

  FiasAddressElement.MATCHING_TYPES = {
    'р-н': FiasFields.district,
    г: FiasFields.city,
    нп: FiasFields.settlement,
    ул: FiasFields.street
  };
  FiasAddressElement.FEDERAL_CITIES = ['0c5b2444-70a0-4932-980c-b4dc0d3f02b5', 'c2deb16a-0330-4f05-821f-1d09c93331e6', '6fdecb78-893a-4e3f-a5ba-aa062459463b', '63ed1a35-4be6-4564-a1ec-0c51f7383314' // Байконур
  ];
  return FiasAddressElement;
}();

export { FiasAddressElement };